// The change card (data-model.md "change_cards"; shift-engine §7 gate 4).
//
// The plain-language record of what a fix did, in the app's own terms. It is the
// customer-facing artifact and the thing the second-model gate matches against the diff.
//
// INVARIANT (D27): a change card carries NO cost, token, or category field. Cost and
// category are internal (the run ledger and fixes.category are admin-only, 00-architecture
// invariant 8); a card the customer sees must not leak them. This type has no such field
// by construction, and a model test asserts it at both the runtime and the type level.
import { z } from "zod";
import { ChangeCardId, FixId } from "../ids.js";
import { NonEmptyString, Timestamp } from "./common.js";
export const ChangeCard = z.object({
    id: ChangeCardId,
    fixId: FixId,
    /** Plain-language summary in the app's brand voice. */
    summary: NonEmptyString,
    /** What changed, as a human-readable list (data-model.md what_changed jsonb). */
    whatChanged: z.array(NonEmptyString),
    /** The tests added or run, as a human-readable list (data-model.md tests jsonb). */
    tests: z.array(NonEmptyString),
    /** The file paths this fix touched. */
    filesChanged: z.array(NonEmptyString),
    /** Customer-facing value framing (e.g. "saved ~2 hours of debugging"). Never a cost. */
    savedEstimate: NonEmptyString,
    createdAt: Timestamp,
});
//# sourceMappingURL=change-card.js.map